import { useMemo } from 'react';
import { format as formatDate, isThisYear } from 'date-fns';
import type { ActivityLogItemType } from '@sdk/shifts/types/ActivityLogType';
import Text14 from '@sdk/components/ui/typography/Text14';
import Text12 from '@sdk/components/ui/typography/Text12';
import Row from '@sdk/components/ui/spacing/Row';
import HorizontalSeparator from '@sdk/components/ui/HorizontalSeparator';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import formatTime from '@sdk/utils/dateFormat/formatTime';
import useAuth from '@sdk/authentication/useAuth';

import { ActivityLogItemContanier } from '@web/shifts/ActivityLogItem/activityLogItem.styles';
import { getActivityLogItemSummary } from '@web/shifts/ActivityLogItem/activityLogItem.utils';

type Props = {
  item: ActivityLogItemType;
  showSeparator: boolean;
  onItemClick: (value: ActivityLogItemType) => void;
};

const ActivityLogItem = ({ item, showSeparator, onItemClick }: Props) => {
  const { currentUser } = useAuth();
  const [summaryText, summaryColor] = useMemo(() => getActivityLogItemSummary(item), [item]);
  const dateFormat = isThisYear(item.createdAt)
    ? formatDate(item.createdAt, 'MMM dd · ')
    : formatDate(item.createdAt, 'MMM dd, yyyy · ');
  return (
    <>
      <ActivityLogItemContanier onClick={() => onItemClick(item)}>
        <Row>
          <Text14 themeColor={ThemeColorType.gray}>{item.actor.fullname}</Text14>
        </Row>
        <Row>
          <Text14 themeColor={summaryColor}>{summaryText}</Text14>
        </Row>
        <Row mTop={10}>
          <Text12 semiBold themeColor={ThemeColorType.iconGray}>
            {dateFormat}
            {formatTime(item.createdAt, currentUser.settings.usTimeFormat)}
          </Text12>
        </Row>
      </ActivityLogItemContanier>
      {showSeparator && (
        <Row pRight={10} pLeft={10}>
          <HorizontalSeparator />
        </Row>
      )}
    </>
  );
};

export default ActivityLogItem;
